class PalmstreetReviewsCarousel extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('.palmstreet-reviews__grid');
    if (!this.grid) return;

    this.autoplay = this.dataset.autoplay === 'true';
    this.speed = parseInt(this.dataset.speed, 10) || 4000;
    this.mediaQuery = window.matchMedia('(max-width: 749px)');

    this.handleChange = this.handleChange.bind(this);
    this.handleChange(this.mediaQuery);
    this.mediaQuery.addEventListener('change', this.handleChange);

    this.grid.addEventListener('pointerdown', () => this.pause());
    this.grid.addEventListener('mouseenter', () => this.pause());
    this.grid.addEventListener('mouseleave', () => {
      if (this.mediaQuery.matches && this.autoplay) this.start();
    });
  }

  disconnectedCallback() {
    this.pause();
    this.mediaQuery.removeEventListener('change', this.handleChange);
  }

  handleChange(mq) {
    if (mq.matches && this.autoplay) {
      this.start();
    } else {
      this.pause();
    }
  }

  start() {
    this.pause();
    this.interval = setInterval(() => this.next(), this.speed);
  }

  pause() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }

  next() {
    const cards = this.grid.querySelectorAll('.palmstreet-reviews__card');
    if (!cards.length) return;

    const gap = parseFloat(getComputedStyle(this.grid).columnGap) || 0;
    const step = cards[0].offsetWidth + gap;
    const max = this.grid.scrollWidth - this.grid.clientWidth - 4;

    if (this.grid.scrollLeft >= max) {
      this.grid.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      this.grid.scrollBy({ left: step, behavior: 'smooth' });
    }
  }
}

if (!customElements.get('palmstreet-reviews-carousel')) {
  customElements.define('palmstreet-reviews-carousel', PalmstreetReviewsCarousel);
}
